import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  attribute: null,
  loading: false,
  editAttributeNameLoading: false,
  editValueLoading: false,
  delAttributeBtnLoading: false,
  delValueBtnLoading: false,
  editAttributeBtnLoading: false,
  addValueBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ATTRIBUTE_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
